import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, endpoints } from "@/lib/api";
import { Mail } from "lucide-react";

export const NewsletterForm = ({ variant = "light" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const dark = variant === "dark";

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await api.post(endpoints.newsletter, { email });
      setDone(true);
      toast.success(res.status === "already_subscribed" ? "You’re already subscribed — thank you!" : "Subscribed. Watch out for our next impact update.");
    } catch (err) {
      toast.error(err?.response?.data?.detail?.[0]?.msg || "Please enter a valid email.");
    } finally { setLoading(false); }
  };

  if (done) return (
    <div className={`rounded-md p-3 text-sm ${dark ? "bg-white/10 text-white" : "bg-[hsl(var(--surface-tint-green))] text-[hsl(var(--green))]"}`} data-testid="newsletter-form-success">Thank you — we’ll be in touch soon.</div>
  );

  return (
    <form onSubmit={onSubmit} className="flex flex-col sm:flex-row items-stretch gap-2" data-testid="newsletter-form">
      <div className="relative flex-1">
        <Mail className={`absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 ${dark ? "text-white/60" : "text-[hsl(var(--muted-ink))]"}`} />
        <Input
          data-testid="newsletter-form-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className={`pl-9 ${dark ? "bg-white/10 border-white/20 text-white placeholder-white/60" : ""}`}
        />
      </div>
      <Button type="submit" disabled={loading} data-testid="newsletter-form-submit" className={dark ? "bg-[hsl(var(--orange))] hover:bg-[hsl(var(--orange-2))] text-black font-semibold" : "bg-[hsl(var(--navy))] hover:bg-[hsl(var(--navy-2))] text-background"}>
        {loading ? "Subscribing..." : "Subscribe"}
      </Button>
    </form>
  );
};
